module.exports = __webpack_public_path__ + "static/media/apexgreensmall.e372a821.gif";